<!-- 목록 화면 로딩 모양: 검색 조건(표 + 오른쪽 조회 버튼) / 툴바 / 그리드 -->
<div class="d-flex flex-column h-100 placeholder-glow">

    <!-- 검색 조건: filterRowCnt 가 0 이면 그리지 않고, 1 이상이면 한 줄만 그린다 -->
    <div class="np-form-table mb-2" *ngIf="filterRowCnt > 0">
        <div class="row g-0">
            <div class="np-col-set col" *ngFor="let j of counter(4)">
                <div class="np-col-head"><span class="placeholder bs5-ph-label"></span></div>
                <div class="np-col-cell"><span class="placeholder bs5-ph-input"></span></div>
            </div>
        </div>
        <div class="np-search-actions">
            <span class="btn btn-sm btn-primary disabled placeholder"></span>
            <span class="btn btn-sm btn-outline-secondary disabled placeholder"></span>
        </div>
    </div>

    <!-- 툴바 -->
    <div class="bs5-ph-toolbar">
        <span class="placeholder bs5-ph-btn"></span>
        <span class="placeholder bs5-ph-btn"></span>
        <span class="placeholder bs5-ph-btn"></span>
    </div>

    <!-- 그리드 -->
    <div class="bs5-ph-grid">
        <div class="bs5-ph-grid-header">
            <span class="placeholder col-12"></span>
        </div>
        <div class="bs5-ph-grid-body">
            <span class="placeholder col-12" *ngFor="let i of counter(8)"></span>
        </div>
        <div class="bs5-ph-grid-footer">
            <span class="placeholder col-3"></span>
        </div>
    </div>

</div>
